import { KioskResource } from './KioskResource';

export class ContactDetailsResource {
    rid: number;
	clientEmail: string;
	titleRo: string;
	titleFr: string;
	titleEn: string;
	titleDe: string;
	descriptionRo: string;
	descriptionFr: string;
	descriptionEn: string;
	descriptionDe: string;
	image: string;
    imageString: string;
    kioskList: KioskResource[];
}